export function isMicrosoftEdge() {
  if (typeof navigator === 'undefined') {
    return false
  }

  const brands = navigator.userAgentData && navigator.userAgentData.brands
  if (Array.isArray(brands) && brands.length > 0) {
    const isEdgeBrand = brands.some(
      item => item && /Microsoft Edge/i.test(item.brand)
    )
    if (isEdgeBrand) {
      return true
    }
  }

  return /Edg/i.test(navigator.userAgent || '')
}
